// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"418":"81e1de59f9d69fac4a23","780":"e1c158972d15f71a54bf"}[chunkId] + ".js";
};